/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The first column becomes the x-axis labels.`)
};

const es_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La primera columna se convierte en las etiquetas del eje X.`)
};

const de_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die erste Spalte wird zu den x-Achsen-Beschriftungen.`)
};

const nl_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De eerste kolom wordt de x-as-labels.`)
};

const fr_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La première colonne devient les étiquettes de l'axe des x.`)
};

const it_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La prima colonna diventa le etichette dell'asse x.`)
};

const pt_br2_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira coluna se torna os rótulos do eixo x.`)
};

const pt_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A primeira coluna torna-se os rótulos do eixo X.`)
};

const ja_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初の列がx軸ラベルになります。`)
};

const zh_area_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`第一列成为 x 轴标签。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const area_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.area_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("area_ex3", locale)
	if (locale === "en") return en_area_ex3(inputs)
	if (locale === "es") return es_area_ex3(inputs)
	if (locale === "de") return de_area_ex3(inputs)
	if (locale === "nl") return nl_area_ex3(inputs)
	if (locale === "fr") return fr_area_ex3(inputs)
	if (locale === "it") return it_area_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_area_ex3(inputs)
	if (locale === "pt") return pt_area_ex3(inputs)
	if (locale === "ja") return ja_area_ex3(inputs)
	return zh_area_ex3(inputs)
};